import { render, staticRenderFns } from "./WordpressPagination.vue?vue&type=template&id=5d11bebc&"
import script from "./WordpressPagination.vue?vue&type=script&lang=js&"
export * from "./WordpressPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports